import {useDispatch, useSelector} from 'react-redux';
import {RootState} from 'redux/reducer';

export const useMyTeamsContext = () => {
  const dispatch = useDispatch();

  const filtersRedux = useSelector((state: RootState) => state.myTeams.filters);
  const reduxActiveTab = useSelector(
    (state: RootState) => state.myTeams.selectedTab,
  );
  const reduxIsViewTeam = useSelector(
    (state: RootState) => state.myTeams.isViewTeam,
  );
  const viewTeamsRedux = useSelector((state: any) => state.myTeams?.viewTeams);
  const reduxScreenContext = useSelector(
    (state: RootState) => state.myTeams.screenContext,
  );
  return {
    dispatch,
    filtersRedux,
    reduxActiveTab,
    reduxIsViewTeam,
    viewTeamsRedux,
    reduxScreenContext,
  };
};
